import type { IntegerItem as IntegerItemType } from '@webforge-survey/shared';
import { ItemShell } from './ItemShell';

interface IntegerItemProps {
  item: IntegerItemType;
  value: number | null;
  error?: string;
  onChange: (value: number | null) => void;
}

/**
 * integer : input number avec min/max. Pas de spinner JS perso — on s'appuie
 * sur le natif, qui est correctement annoncé par les lecteurs d'écran.
 *
 * inputMode="numeric" pour clavier numérique mobile.
 */
export function IntegerItem({ item, value, error, onChange }: IntegerItemProps) {
  const inputId = `input-${item.name}`;
  return (
    <ItemShell
      name={item.name}
      label={item.label}
      {...(item.hint !== undefined && { hint: item.hint })}
      {...(item.required !== undefined && { required: item.required })}
      {...(error !== undefined && { error })}
    >
      <input
        id={inputId}
        type="number"
        inputMode="numeric"
        className="input-base max-w-[10rem]"
        value={value ?? ''}
        min={item.min}
        max={item.max}
        step={1}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === '') {
            onChange(null);
            return;
          }
          const n = parseInt(raw, 10);
          onChange(Number.isFinite(n) ? n : null);
        }}
        aria-describedby={item.hint ? `${item.name}-hint` : undefined}
      />
      {(item.min !== undefined || item.max !== undefined) && (
        <p className="text-xs text-text-muted mt-2">
          {item.min !== undefined && item.max !== undefined
            ? `Valeur attendue entre ${item.min} et ${item.max}.`
            : item.min !== undefined
              ? `Au minimum ${item.min}.`
              : `Au maximum ${item.max}.`}
        </p>
      )}
    </ItemShell>
  );
}
